import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { push } from 'connected-react-router';
import { CreateReleaseSuccess } from '../action-creators';
import { CREATE_RELEASE_SUCCESS } from '../actions';

export const updateDraftURLEpic = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, CreateReleaseSuccess>(CREATE_RELEASE_SUCCESS),
    withLatestFrom(state$),
    filter(([action, state]) => {
      const id = action.release.id;

      return !!(
        id &&
        state.router.location.pathname.startsWith('/release/') &&
        !state.router.location.pathname.includes(id)
      )
    }),
    map(([action, state]) => {
      const section = state.router.location.pathname.split('/').slice(-1)
      const artistId = state.artist.active?.id;
      const path = ['', 'release', artistId, action.release.id].concat(section);

      return push(path.join('/'))
    })
  );
